export const siteConfig = {
  name: 'SpecifiC',
  freeHa: 100,
  minHa: 5,
  urls: {
    app: 'https://app.specific-ag.com',
    api: 'https://app.specific-ag.com',
    marketing: 'https://www.specific-ag.com',
    demo: 'mailto:ventas@specific-ag.com?subject=Demo%20SpecifiC%20AG',
    support: 'mailto:soporte@specific-ag.com',
  },
  social: {
    whatsapp: 'https://wa.me/+5493584925325',
    instagram: 'https://www.instagram.com/specificag',
  },
  anchors: {
    map: 'ambientador',
    howItWorks: 'como-funciona',
    value: 'beneficios',
    trust: 'experiencias',
  },
};
